import React, {forwardRef, useState} from 'react';
import {StyleProp, StyleSheet, TextStyle} from 'react-native';
import {Input as RNEInput, InputProps as RNEInputProps} from '@rneui/themed';

import {fontFamilyStyle} from '../Text';

export type TextInputProps = RNEInputProps & {
  touched?: boolean;
  errorMessageWhenTouched?: string;
  inputFocusStyle?: StyleProp<TextStyle>;
};

type RNEInputType = typeof RNEInput;

const commonTextStyles = {
  ...fontFamilyStyle,
};

const TextInput = forwardRef<RNEInputType, TextInputProps>(
  (
    {
      autoCorrect = false,
      errorMessage,
      errorMessageWhenTouched,
      renderErrorMessage = true,
      autoCapitalize = 'none',
      returnKeyLabel = 'next',
      returnKeyType = 'next',
      touched,
      inputStyle,
      inputFocusStyle,
      value,
      defaultValue,
      ...rest
    }: TextInputProps,
    ref,
  ) => {
    // We are usually working with Formik. This is something like:
    // https://formik.org/docs/api/errormessage.
    let errorMessageOrPlaceholder = errorMessage;
    if (touched && errorMessageWhenTouched) {
      errorMessageOrPlaceholder = errorMessageWhenTouched;
    }
    if (renderErrorMessage && !errorMessageOrPlaceholder) {
      errorMessageOrPlaceholder = ' ';
    }

    const [focused, setFocused] = useState(false);

    return (
      <RNEInput
        onBlur={() => {
          setFocused(false);
          rest.onBlur?.();
        }}
        onFocus={() => {
          setFocused(true);
          rest.onFocus?.();
        }}
        errorStyle={commonTextStyles}
        labelStyle={commonTextStyles}
        inputStyle={[
          commonTextStyles,
          styles.input,
          inputStyle,
          focused && inputFocusStyle,
        ]}
        autoCapitalize={autoCapitalize}
        autoCorrect={autoCorrect}
        returnKeyLabel={returnKeyLabel}
        returnKeyType={returnKeyType}
        errorMessage={errorMessageOrPlaceholder}
        ref={ref}
        {...rest}
        value={value !== undefined ? value : undefined}
        defaultValue={
          value === undefined && defaultValue !== undefined
            ? defaultValue
            : undefined
        }
        renderErrorMessage={renderErrorMessage} // This doesn't work?
      />
    );
  },
);

const styles = StyleSheet.create({
  input: {
    paddingHorizontal: 4,
  },
});

export default TextInput;
